import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import CreditMemoGrid from '../../../features/distributor/credit-memo-grid/components/CreditMemoGrid';

export default function CreditMemosPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Credit Memos List')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<CreditMemoGrid />
			</div>
		</React.Fragment>
	)
} 
